import JSXComponent from "../../../dist/jsx-render/JSXComponent";
import dom from "../../../dist/jsx-render/dom";
import { IClientGridView } from "./IClientGridView";
import { TreeView } from "../../Components/TreeView/TreeView";
import { UsedFieldsConverter } from "./UsedFieldsConverter";
import { UsedTreeFieldComponent } from "./UsedTreeFieldComponent";
import { AvailableFieldsComponent } from "./AvailableFieldsComponent";
import { ITreeNodeModel } from "../../Components/TreeView/Models/Interfaces/ITreeNodeModel";
import { TreeNodeModel } from "../../Components/TreeView/Models/TreeNodeModel";
import { ITreeField } from "./ITreeField";
import { TreeNodeComponent } from "../../Components/TreeView/NodeComponents/TreeNodeComponent";

export type UsedFieldsComponentProps = {
    model: IClientGridView,
    availableComponent: AvailableFieldsComponent,
    checkBoxCheckedEvent?: (model: TreeNodeModel, event: Event) => void;

    // DA I added a boolean "inlineEdit" to ITreeField - maybe we can use this also in the GridViewSelect? Then we could remove this prop from here
    // and the parameter from UsedFieldsConverter. @HH ??
    useTreeFieldInlineEditFlag?: boolean;
}

export class UsedFieldsComponent extends JSXComponent {
    private props: UsedFieldsComponentProps;
    public tree: TreeView;

    constructor(props: UsedFieldsComponentProps) {
        super(props);
    }

    element: HTMLElement =
        <div className="used">
        </div>

    render() {
        this.tree = new TreeView({
            businessModel: this.props.model.fields,
            modelConverter: new UsedFieldsConverter(this.props.useTreeFieldInlineEditFlag),
            childrenCollapsed: false,
            internalComponentType: UsedTreeFieldComponent,
            //internalProps: AvailableTreeFieldComponentProps,
            allowDragDrop: true,
            //dragDropBusinessModelAction: this.updateCategoryContentAfterDragDrop,
            dropTargetClass: "tree-drop",
            insertOnTop: true,
            isDebug: false,
            dropOnSameLevel: true,
            createTreeNodeModelOnDrop: this.createNewNode,
            allowSelect: this.props.model.useInlineEdit,
            checkboxCheckedEvent: (node: TreeNodeModel, event: Event) => {
                if (this.props.checkBoxCheckedEvent) this.props.checkBoxCheckedEvent(node, event);
            }
        });
        this.element.appendChild(this.tree.render());

        // Drag and drop functionality for Used Tree view (separate from tree view element drag and drop functionality) 
        this.element?.addEventListener('dragover', this.allowDrop);
        this.element?.addEventListener('drop', this.drop);

        return this.element;
    }

    private allowDrop = (event: DragEvent) => {
        event.preventDefault();
        event.stopPropagation();
        event.dataTransfer.setData("elementId", this.element.id);
    }
   
    private drop = (event: DragEvent) => {
        event.stopPropagation();
        event.preventDefault();

        let draggedId = event.dataTransfer.getData("elementId");

        // Search for the id of the dragged node in the Used tree list.
        let node = this.tree.nodes.find(n => n.clientId == draggedId);

        if (node) {
            // If the node was found in the Used tree list, 
            // then it will be moved to the end of the list.
            this.moveNodeToEndOfList(node);
        }
        else {
            // If the node was not found in the Used tree list, 
            // then it will be created and added to the end of the list.
            this.addNodeToEndOfList(draggedId);
        }
    }

    createNewNode = (elementId: string): ITreeNodeModel => {
        const model = this.props.availableComponent.getModelFromTree(elementId);
        if (model) {

            // Create a copy of the model object, otherwise adding several instances of 
            // the same field with different iterations will lead to errors and iterations cannot be edited independently.
            let modelCopy = {};
            for (let key in model) {
                modelCopy[key] = model[key];
            }

            const node = new TreeNodeModel();
            node.businessModel = modelCopy;
            node.children = [];
            return node;
        }
        return null;
    }

    //Move node to the end of the list.
    private moveNodeToEndOfList = (node: TreeNodeComponent) => {
        // Remove node from list.
        this.tree.removeNode(node.props.model.businessModel);

        // Add node to the end of the list.
        this.tree.insertRootNode(node.props.model, null);
    }

    // first field to add to usedFields
    // also the last field of a list
    private addNodeToEndOfList = (elementId: string) => {
        let node = this.createNewNode(elementId);

        if (node && node.businessModel) {
            this.tree.insertRootNode(node, null);
        }
    }

    public getSelectedFields = () => {
        return this.tree.nodes
            .filter(n => !n.props.model.businessModel.isDeleted)
            .map(n => n.props.model.businessModel);
    }

}
